module.exports = __webpack_public_path__ + "static/media/66.a296b6da.jpg";